import React from 'react';
import { inject, observer} from 'mobx-react';
import {WeaTop, WeaTab,WeaRightMenu,WeaErrorPage,WeaSearchGroup,WeaFormItem,WeaSelect,WeaAlertPage,} from 'ecCom';
import {Row,Form,Col,Button} from 'antd';
import * as mobx from 'mobx';
import isEmpty from 'lodash/isEmpty';
const toJS = mobx.toJS;
import * as PublicFunc from '../util/pulic-func';
window.openFullWindowForXtable = PublicFunc.openFullWindowForXtable;
import moment from 'moment';
import {WeaTableNew,WeaSwitch} from 'comsMobx';
import {i18n} from '../public/i18n';
const WeaTable = WeaTableNew.WeaTable;
let _this;

@inject('hrmBirthdayInfo')

@observer
class BirthdayInfo extends React.Component {
  constructor(props) {
    super(props);
    _this = this;
    const funcs = ['jumpToHrmCard'];
    funcs.forEach(f=> this[f] = this[f].bind(this))
  }

  componentDidMount() {
    const { hrmBirthdayInfo } = this.props;
    hrmBirthdayInfo.getHasRight();
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.location.key !== nextProps.location.key) {
      const { hrmBirthdayInfo } = this.props;
      hrmBirthdayInfo.getHasRight();
    }
  }

  render(){
    const { hrmBirthdayInfo } = this.props;
    const {title,form,table,showSearchAd,searchParamsAd,verified,hasRight} = hrmBirthdayInfo;

    if (verified && hasRight) {
      const formParams = form.getFormParams();
      return (
        <div className='wea-myhrm-Online'>
        <WeaRightMenu datas={this.getRightMenu()} onClick={this.onRightMenuClick.bind(this)}>
          <WeaTop
            title={title()}
            icon={<i className='icon-coms-hrm' />}
            iconBgcolor='#217346'
            buttons={[]}
            buttonSpace={10}
            showDropIcon={false}
          >
          <WeaTab
            buttonsAd={this.getTabButtonsAd()}
            searchType={['base','advanced']}
            searchsBaseValue={formParams.lastname}
            setShowSearchAd={bool => {hrmBirthdayInfo.setShowSearchAd(bool)}}
            hideSearchAd={() => hrmBirthdayInfo.setShowSearchAd(false)}
            searchsAd={<Form horizontal>{this.getSearchs()}</Form>}
            showSearchAd={showSearchAd}
            onSearch={v => {hrmBirthdayInfo.doSearch()}}
            onSearchChange={v => {
              form.updateFields({
                  lastname:{name:'lastname',value:v},
                });
              }}
          />
          <WeaTable
            comsWeaTableStore={table}
            hasOrder={true}
            needScroll={true}
            getColumns={c=>this.reRenderColumns(c)}
            />
          </WeaTop>
          </WeaRightMenu>
        </div>
      );
    }
    if (verified && !hasRight) {
        return (<WeaAlertPage >
                <div style={{color : '#000'}}>
                    {i18n.message.authFailed()}
                </div>
            </WeaAlertPage>
        )
    }
    return (
        <div></div>
    )
  }

  getSearchs() {
    const { hrmBirthdayInfo } = this.props;
    const { form,condition } = hrmBirthdayInfo;
    const {isFormInit} = form;
    let group = [];
    let  monthOptions= hrmBirthdayInfo.getMonth();
    let  dayOptions= hrmBirthdayInfo.getDay();

    const formParams = form.getFormParams();
    const month = new moment().format('MM');
    isFormInit && toJS(condition).map(c =>{
      let items = [];
      c.items.map(fields => {
        let hide = false;
        let dom;
        if (fields.domkey[0] == 'bDate') {
          hide = true;
        }if (fields.domkey[0] == 'bMonth') {
          dom = <Row>
          <Col span={10} style={{'margin-right':'5px'}}>
            <WeaSelect options={monthOptions} value={formParams.bMonth||month} onChange={v => {
              form.updateFields({
                bMonth:{name:'bMonth',value:v},
              });
            }}/>
          </Col>
          <Col span={10}>
            <WeaSelect options={dayOptions} value={formParams.bDate||''} onChange={v => {
              form.updateFields({
                bDate:{name:'bDate',value:v},
              });
            }}/>
          </Col>
        </Row>
        }else {
          dom =  <WeaSwitch fieldConfig={fields} form={form} formParams={formParams}/>;
        }
        items.push({
          com:(<WeaFormItem
              label={`${fields.label}`}
              labelCol={{span: `${fields.labelcol}`}}
              wrapperCol={{span: `${fields.fieldcol}`}}>
                {dom}
              </WeaFormItem>),
          colSpan:1,
          hide: hide
        })
      });
      group.push(<WeaSearchGroup needTigger={true} title={c.title} showGroup={c.defaultshow} items={items}/>)
    });
    return group;
  }

  reRenderColumns(columns){
    columns.forEach(c=>{
        if(c.dataIndex=='lastname'){
            c.render = function(text, record){
                return  <span style={{cursor:'pointer'}} className='wea-hrm-linkstyle' onClick={_this.jumpToHrmCard.bind(null,record.id)}>{record.lastname}</span>
            }
        } else {
          c.render = function(text, record){
              let valueSpan = record[c.dataIndex + "span"] !== undefined ? record[c.dataIndex + "span"] : record[c.dataIndex];
              return <span dangerouslySetInnerHTML={{__html: valueSpan}}></span>
            }
        }
    })
    return columns;
  }

  jumpToHrmCard(hrmId,...rest){
    PublicFunc.jumpToHrmCard(hrmId);
  }

  getRightMenu(){
    const keys = this.getSelectedRowKeys();
    const arr = [{
        icon: <i className='icon-coms-ws'/>,
        content:i18n.button.search()
      }, {
        icon: <i className='icon-coms-task-list'/>,
        content:i18n.button.columnVisibleSetting()
      }
    ];
    return arr;
  }

  onRightMenuClick(key){
    const { hrmBirthdayInfo } = this.props;
    switch(key){
        case '0':
            hrmBirthdayInfo.doSearch();
            break;
        case '1':
            this.definedColumn();
            break;
    }
  }

  getSelectedRowKeys(){
    const { hrmBirthdayInfo } = this.props;
    const { table} = hrmBirthdayInfo;
    const selectedRowKeys = table.selectedRowKeys;
    return selectedRowKeys;
  }

  definedColumn() {
    const { hrmBirthdayInfo } = this.props;
    const { table} = hrmBirthdayInfo;
    table.setColSetVisible(true);
    table.tableColSet(true);
  }

  getTabButtonsAd() {
    const { hrmBirthdayInfo } = this.props;
    const { form,searchParamsAd } = hrmBirthdayInfo;
    return [
        (<Button type="primary" onClick={()=>{hrmBirthdayInfo.doSearch();hrmBirthdayInfo.setShowSearchAd(false)}}>{i18n.button.search()}</Button>),
        (<Button type="ghost" onClick={()=>{form.reset();
          form.updateFields({
            bMonth:{value: new moment().format('MM')},
          });
        }}>{i18n.button.reset()}</Button>),
        (<Button type="ghost" onClick={()=>{hrmBirthdayInfo.setShowSearchAd(false)}}>{i18n.button.cancel()}</Button>)
    ]
  }
}

export default BirthdayInfo



// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/BirthdayInfo.js